<template>
    <div>
        <h1>Redirecting to verification page</h1>
        <div>
            <Spinner v-if="!isComplete" size="huge" />
        </div>
    </div>
  
</template>

<script>
import Spinner from 'vue-simple-spinner'


export default {
    components: {
        Spinner
    },
    created() {
        window.location.href = "http://developer.globelabs.com.ph/dialog/oauth/rdArSaL5zLh5riGn6qc5g6hq6dp8SEaK";
    }
}
</script>

<style>

</style>